import { classNames } from "@/utils/utils";
import React, { HTMLAttributes } from "react";

import styles from "./Button.module.css";

type Props = HTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "secondary" | "clean";
  className?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  children?: React.ReactNode;
};
export const Button: React.FC<Props> = ({
  children,
  variant = "primary",
  className,
  type = "button",
  ...rest
}) => {
  return (
    <button
      {...rest}
      type={type}
      className={classNames(styles.button, styles[variant], className)}
    >
      {children}
    </button>
  );
};
